import { fieldMapping } from './shipmentFieldMapping';

/**
 * flat한 Redux state 리스트들을 nested 구조로 변환합니다.
 *
 * @param {number} tabValue          - shipment type (0~4)
 * @param {object} selectedRow       - 메인 테이블 선택 row
 * @param {Array}  hblShipmentList   - Redux hbl/hawb/bol 리스트
 * @param {Array}  cntrShipmentList  - Redux container/alias 리스트
 * @param {Array}  splitShipmentList - Redux split(cntr_alias) 리스트 (Ocean Import only)
 * @param {Function} setShipmentList - nested 결과를 저장할 setter
 *
 * 결과 구조:
 *   Ocean Import  : { ...main, hblList: [{ ...hbl, cntrList: [{ ...cntr, splitList: [...] }] }] }
 *   Ocean Export  : { ...main, hblList: [{ ...hbl, cntrList: [...] }] }
 *   Air Im/Export : { ...main, hblList: [{ ...hbl, cntrList: [...alias] }] }
 *   FTL/LTL       : { ...main, hblList: [...bol] }
 */
export const buildShipmentList = (
    tabValue,
    selectedRow,
    hblShipmentList,
    cntrShipmentList,
    splitShipmentList,
    setShipmentList,
) => {
    if (!selectedRow?.id) {
        setShipmentList(null);
        return;
    }

    const mapping = fieldMapping[tabValue];
    if (!mapping) {
        setShipmentList(null);
        return;
    }

    const { mainId, hblId, cntrId, split } = mapping;

    const hblFiltered = (hblShipmentList ?? []).filter((hbl) => hbl[mainId] === selectedRow.id);

    const nestedHblList = hblFiltered.map((hbl) => {
        // FTL/LTL: cntr 없음
        if (!cntrShipmentList) return { ...hbl };

        const cntrFiltered = (cntrShipmentList ?? []).filter((cntr) => cntr[hblId] === hbl.id);

        // split 없음 (Ocean Export, Air Im/Export)
        if (!split) return { ...hbl, cntrList: cntrFiltered };

        // split 있음 (Ocean Import only)
        const nestedCntrList = cntrFiltered.map((cntr) => ({
            ...cntr,
            splitList: (splitShipmentList ?? []).filter((sp) => sp[cntrId] === cntr.id),
        }));

        return { ...hbl, cntrList: nestedCntrList };
    });

    setShipmentList({ ...selectedRow, hblList: nestedHblList });
};
